import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '@core/config/api-url.token';
import { SUPPRESS_ERROR_TOAST } from '@core/http/http-context-tokens';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { ProvetDiagnosticsScope } from '../../../domain/models/provet-diagnostics.model';
import { ProvetDiagnosticsSnapshotDto } from '../../dtos/provet-diagnostics.dto';

// The panel drives its own loop at up to 2 polls/second and renders every failure inline, so the
// global error toast does not apply: a 503 here means "no provider connection yet", not "the app
// is down".
function diagnosticsContext(): HttpContext {
  return new HttpContext().set(SUPPRESS_ERROR_TOAST, true);
}

@Injectable()
export class ProvetDiagnosticsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public fetchSnapshot(
    since: number | null,
    scope: ProvetDiagnosticsScope,
  ): Observable<ProvetDiagnosticsSnapshotDto> {
    let params = new HttpParams().set('scope', scope);
    if (since !== null) params = params.set('since', since);

    return this.http.get<ProvetDiagnosticsSnapshotDto>(
      `${this.apiUrl}${API_ENDPOINTS.provetDiagnostics.snapshot}`,
      { params, context: diagnosticsContext() },
    );
  }

  public reset(): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}${API_ENDPOINTS.provetDiagnostics.reset}`,
      null,
      { context: diagnosticsContext() },
    );
  }
}
